const Spinner = () => {
    return (
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"/>
    );
}

export default Spinner;